<template>

  <DocsPageTemplate apiDocs>
    <DocsPageSection
      title="Overview"
      anchor="#overview"
    >
      <p>
        <code>KListboxGroup</code> groups a set of <code>KListboxOption</code> children under a
        labelled ARIA group. See <DocsLibraryLink component="KListbox" /> for guidance and examples.
      </p>
    </DocsPageSection>
  </DocsPageTemplate>

</template>


<script>

  export default {
    name: 'KListboxGroupDocs',
  };

</script>
